import React, { useState, useRef, useEffect, useCallback } from 'react';
import { REMOVE_TOAST_TIME_MILLISECONDS, ANIMATION_TIME_MILLISECONDS } from './constants.js';
import { ToastsContainer } from './styles.js';
import { ToastItem } from './ToastItem.js';

function Toast({ toasts, id, removeToastTime = REMOVE_TOAST_TIME_MILLISECONDS, }) {
    const [list, setList] = useState(toasts);
    const dialogRootRef = useRef(null);
    useEffect(() => {
        setList([...toasts]);
    }, [toasts]);
    useEffect(() => {
        const interval = setInterval(() => {
            if (toasts.length && list.length) {
                const listsCopy = list.slice(1);
                setList([Object.assign(Object.assign({}, toasts[0]), { hide: true }), ...listsCopy]);
                setTimeout(() => {
                    const currentToast = toasts[0];
                    if (currentToast)
                        handleClose(currentToast.id);
                }, ANIMATION_TIME_MILLISECONDS);
            }
        }, removeToastTime);
        return () => clearInterval(interval);
    }, [toasts, list]);
    useEffect(() => {
        var _a, _b, _c, _d;
        if (list.length && !((_a = dialogRootRef.current) === null || _a === void 0 ? void 0 : _a.open)) {
            (_b = dialogRootRef.current) === null || _b === void 0 ? void 0 : _b.show();
        }
        if (!list.length && ((_c = dialogRootRef.current) === null || _c === void 0 ? void 0 : _c.open)) {
            (_d = dialogRootRef.current) === null || _d === void 0 ? void 0 : _d.close();
        }
    }, [list]);
    const handleClose = useCallback((id) => {
        const listItemIndex = list.findIndex((item) => item.id === id);
        const toastItemIndex = toasts.findIndex((item) => item.id === id);
        const removed = list.splice(listItemIndex, 1);
        toasts.splice(toastItemIndex, 1);
        removed.map((item) => {
            if (item.onClose) {
                item.onClose.call(item, item.id);
            }
        });
        setList([...list]);
    }, [list, toasts]);
    return (React.createElement(ToastsContainer, { id: id || 'toasts-dialog', ref: dialogRootRef }, list.map((toast) => (React.createElement(ToastItem, { key: toast.id, id: toast.id, message: toast.message, icon: toast.icon, hideInfoIcon: toast.hideInfoIcon, link: toast.link, variation: toast.variation, onClose: handleClose, hide: toast.hide || false })))));
}

export { Toast };
